import { Block, GenericDropdown, Label } from '@/forms-legacy'
import { useRecurrenceType } from '../../../providers/StateProvider'
import { useOptions } from './useOptions'
import { useOnChange } from './useOnChange'
import { useTexts } from './useTexts'

export type RecurrenceTypeDropdownProps = {
  testId?: string
}

export function RecurrenceTypeDropdown(props: RecurrenceTypeDropdownProps) {
  const { testId = 'RecurrenceTypeDropdown' } = props
  const type = useRecurrenceType()
  const options = useOptions()
  const onChange = useOnChange()
  const texts = useTexts()

  return (
    <Block data-testid={testId}>
      <Label>{texts.label}</Label>
      <GenericDropdown
        name="recurrenceType"
        selectedIds={[type]}
        values={options}
        onChanged={onChange}
      />
    </Block>
  )
}
